import { Fragment } from 'react';

import UnitLessonCardList from '@/components/lesson/UnitLessonCardList';
import UnitLessonProgressItem from '@/components/lesson-progress/UnitLessonProgressItem';
import { UnitOverviewCard } from '@/components/unit/UnitOverviewCard';
import useUnitLessonProgresses from '@/data/hook/lesson-progress/useUnitLessonProgresses';
import useLessonNameFormatter from '@/data/hook/lesson/useLessonNameFormatter';
import { CourseRoute } from '@/utils/routes';

type StudentUnitLessonsProps = CourseRoute & {
  unitId: number;
  courseProgressId: number;
};

export default function StudentUnitLessons({
  unitId,
  courseProgressId,
  slug,
  klassId,
}: StudentUnitLessonsProps) {
  const {
    results,
    isInitialLoading,
    error,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    completedLessons,
    totalLessons,
  } = useUnitLessonProgresses({ courseProgressId, unitId });
  const lessonNameFormatter = useLessonNameFormatter();
  const { isLoading: isLoadingCourse } = lessonNameFormatter;

  return (
    <Fragment>
      <UnitOverviewCard.LessonsHeader
        completed={completedLessons}
        total={totalLessons}
      />
      <UnitLessonCardList
        isLoading={isInitialLoading || isLoadingCourse}
        isEmpty={!results.length}
        hasError={!!error}
        onRetry={() => refetch()}
        onReachEnd={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      >
        {results.map(lessonProgress => (
          <UnitLessonProgressItem
            key={lessonProgress.id}
            lessonProgress={lessonProgress}
            lessonNameFormatter={lessonNameFormatter}
            slug={slug}
            klassId={klassId}
          />
        ))}
      </UnitLessonCardList>
    </Fragment>
  );
}
